<div class="control-tab">
    <!-- <ng-container *ngIf="activatedType != 'list'">
        <span class="show-text">{{'user-management.control-bar.show' | translate}}</span>
        <div class="dropdown hide">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{selectedItemsPerPage}}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <ng-container *ngFor="let item of itemsPerPage">
                    <a (click)="changeRowsNumber(item)" class="dropdown-item">{{item}}</a>
                </ng-container>
            </div>
        </div>
    </ng-container> -->
    <div class="search">
        <input (keyup)="onKeyup($event)" class="search-input" type="text" autocomplete="off" placeholder="{{'user-management.control-bar.search' | translate}}">
    </div>
    <div class="show-style-control style-control">
        <div matTooltip="{{'user-management.control-bar.compact-view' | translate}}">
            <!-- normal view -->
            <svg (click)='setViewType("list")' id="normal-svg" [attr.class]='activatedType == "list"?"active":" " '
                xmlns="http://www.w3.org/2000/svg" width="21.474" height="17" viewBox="0 0 21.474 17">
                <g id="list_1_" data-name="list (1)" transform="translate(0 -53.333)">
                    <g id="Group_5111" data-name="Group 5111" transform="translate(5.82 55.175)">
                        <g id="Group_5110" data-name="Group 5110">
                            <path id="Path_5426" data-name="Path 5426"
                                d="M164.527,96H149.793a.46.46,0,1,0,0,.921h14.733a.46.46,0,1,0,0-.921Z"
                                transform="translate(-149.333 -96)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5113" data-name="Group 5113" transform="translate(5.82 61.373)">
                        <g id="Group_5112" data-name="Group 5112">
                            <path id="Path_5427" data-name="Path 5427"
                                d="M164.527,245.333H149.793a.46.46,0,1,0,0,.921h14.733a.46.46,0,1,0,0-.921Z"
                                transform="translate(-149.333 -245.333)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5115" data-name="Group 5115" transform="translate(5.82 67.571)">
                        <g id="Group_5114" data-name="Group 5114">
                            <path id="Path_5428" data-name="Path 5428"
                                d="M164.527,394.667H149.793a.46.46,0,1,0,0,.921h14.733a.46.46,0,1,0,0-.921Z"
                                transform="translate(-149.333 -394.667)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5117" data-name="Group 5117" transform="translate(0 65.729)">
                        <g id="Group_5116" data-name="Group 5116">
                            <path id="Path_5429" data-name="Path 5429"
                                d="M2.3,352a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,2.3,352Zm0,3.683A1.381,1.381,0,1,1,3.683,354.3,1.383,1.383,0,0,1,2.3,355.683Z"
                                transform="translate(0 -352)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5119" data-name="Group 5119" transform="translate(0 59.531)">
                        <g id="Group_5118" data-name="Group 5118">
                            <path id="Path_5430" data-name="Path 5430"
                                d="M2.3,202.667a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,2.3,202.667Zm0,3.683a1.381,1.381,0,1,1,1.381-1.381A1.383,1.383,0,0,1,2.3,206.35Z"
                                transform="translate(0 -202.667)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5121" data-name="Group 5121" transform="translate(0 53.333)">
                        <g id="Group_5120" data-name="Group 5120">
                            <path id="Path_5431" data-name="Path 5431"
                                d="M2.3,53.333a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,2.3,53.333Zm0,3.683a1.381,1.381,0,1,1,1.381-1.381A1.383,1.383,0,0,1,2.3,57.016Z"
                                transform="translate(0 -53.333)" fill="#707070" />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div matTooltip="{{'user-management.control-bar.list-view' | translate}}">
            <!-- compact view -->
            <svg (click)='setViewType("compact")' id="compact-svg"
                [attr.class]='activatedType == "compact"?"active":" "' xmlns="http://www.w3.org/2000/svg" width="20.395"
                height="14.488" viewBox="0 0 20.395 14.488">
                <g id="Group_5124" data-name="Group 5124" transform="translate(6308 -176)">
                    <g id="Group_5111" data-name="Group 5111" transform="translate(-6308 176)">
                        <g id="Group_5110" data-name="Group 5110">
                            <path id="Path_5426" data-name="Path 5426"
                                d="M169.128,96H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                                transform="translate(-149.333 -96)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5113" data-name="Group 5113" transform="translate(-6308 179.322)">
                        <g id="Group_5112" data-name="Group 5112">
                            <path id="Path_5427" data-name="Path 5427"
                                d="M169.128,245.333H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                                transform="translate(-149.333 -245.333)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5115" data-name="Group 5115" transform="translate(-6308 182.644)">
                        <g id="Group_5114" data-name="Group 5114">
                            <path id="Path_5428" data-name="Path 5428"
                                d="M169.128,394.667H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                                transform="translate(-149.333 -394.667)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5122" data-name="Group 5122" transform="translate(-6308 185.967)">
                        <g id="Group_5112-2" data-name="Group 5112">
                            <path id="Path_5427-2" data-name="Path 5427"
                                d="M169.128,245.333H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                                transform="translate(-149.333 -245.333)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5123" data-name="Group 5123" transform="translate(-6308 189.289)">
                        <g id="Group_5114-2" data-name="Group 5114">
                            <path id="Path_5428-2" data-name="Path 5428"
                                d="M169.128,394.667H149.933a.6.6,0,0,0,0,1.2h19.195a.6.6,0,0,0,0-1.2Z"
                                transform="translate(-149.333 -394.667)" fill="#707070" />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    </div>
</div>